import { baseApiUrl } from "../globals.js";
import signInWithEthereum from "../sendSignature.js";
import getConnectedAddress from "../getConnectedAddress.js";

export default async function regenAorFull(form, web3, setInProgress) {
  await setInProgress(true);
  await signInWithEthereum(
    web3,
    `Ape Rides Arena: You are regenerating image and metadata AOR ID #${form.aorId}`,
    async (res) => {
      console.log(res);
      const address = await getConnectedAddress(web3);
      if (res.message && res.admin && res.nonce) {
        await fetch(`${baseApiUrl}/api/generator/regenerateAorFull`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            nonce: res.nonce,
            caller: address,
            ...form,
          }),
        }).then(async (res) => {
          const result = await res.json();
          if (result.regenerated) {
            await setInProgress(false);
            window.confirm(result.message);
          } else {
            await setInProgress(false);
            window.confirm(result.message);
          }
        });
      } else {
        await setInProgress(false);
        window.alert("ERROR - SIGNATURE REJECTED");
      }
    }
  ).catch(async (e) => {
    await setInProgress(false);
  });
}
